import axios from 'axios';

const api = axios.create({
    baseURL: 'https://api.b4you.com.br'
});

export default api;